import { Box } from "@mui/material";

import { LoanAppDataGrid } from "@features/Solicitudes/components/LoanAppDataGrid";
import { TabSolicitudes } from "@features/Solicitudes/components/TabSolicitudes";
import { useSolicitudesTabsConfig } from "@features/Solicitudes/hooks/useSolicitudesTabsConfig";

export default function Solicitudes() {
    const { configTabs, activeTabIndex, handleOnChangeTab } = useSolicitudesTabsConfig();

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                height: "100%"
            }}>
            <TabSolicitudes
                titleTabs={configTabs.map((tab) => tab.title)}
                onChangeTab={handleOnChangeTab}
                tabActive={activeTabIndex}
            ></TabSolicitudes>
            <LoanAppDataGrid
                refreshData={false}
                listCode={configTabs.at(activeTabIndex)?.code ?? ""}
                cols={configTabs.at(activeTabIndex)?.cols ?? []}
            />
        </Box>
    );
}
